import React, { useState } from 'react';
import { useForm, Controller } from 'react-hook-form';
import { yupResolver } from '@hookform/resolvers/yup';
import * as Yup from 'yup';
import axios from 'axios';
import { Grid, TextField, Button, Box,Typography } from '@mui/material';
import { useAlert } from 'react-alert'
import CancelOutlinedIcon from '@mui/icons-material/CancelOutlined'
import SaveOutlinedIcon from "@mui/icons-material/SaveOutlined";
import DeleteIcon from '@mui/icons-material/Delete'
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogContentText from '@mui/material/DialogContentText';
import DialogTitle from '@mui/material/DialogTitle';
import { Backdrop } from '@mui/material';
import ErrorOutlineIcon from '@mui/icons-material/ErrorOutline';
import EditIcon from '@mui/icons-material/Edit'
import Swal from 'sweetalert2';
import Headroom from "react-headroom";

import ClearIcon from '@mui/icons-material/Clear';
import CloseIcon from '@mui/icons-material/Close';
import { borderRadius } from '@mui/system';
import { Clear } from '@mui/icons-material';
const validationSchema = Yup.object().shape({
 
  name: Yup.string().required('Name is required'), 
  nodesvalues: Yup.string().required('value is required'), 
});


const MyFormRoles = (props) => {
  const { control, handleSubmit, formState: { errors } } = useForm({
    resolver: yupResolver(validationSchema)
  });
  const token = localStorage.getItem("Token")
  const [refresh, setRefresh] = useState(false);
  const [submitting, setSubmitting] = useState(false)
  const [isDialogOpen, setIsDialogOpen] = useState(false);
  const applyRefresh = () => {
    setRefresh(!refresh);
  };

  const parentId = props.parentId
  const nodeId = props.nodeId
  const [data, setData] = useState({}); 
  const [UpdateData, setUpdateData] = useState({}); 
  const handleInputChange = (event) => {
    const { name, value } = event.target;
    setUpdateData(prevState => ({
      ...prevState,
      [name]: value
    }));
  };

  const onSubmit = async (data) => {
    try {
      const postData = {
        ...data,
        name: data.name || props.name,
        id: 0,
        createdBy: props.createdBy,
        updatedBy: props.updatedBy,
        isActive: props.isActive,
        defaultpracticeId: props.defaultpracticeId,
        description: data.nodesvalues !== undefined ? data.nodesvalues : props.nodesvalues,
        parentId: parentId,
      };
  
      const response = await axios.post(
        `${process.env.REACT_APP_API_URL}/Module/AddRoles?defaultpracticeId=${localStorage.getItem('default_paractice')}`,
        postData,
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      );
  
      props.applyRefresh();
      props.handleClose();
  
      Swal.fire({
        title: 'Record Added',
        text: 'Record added successfully',
        icon: 'success',
        timer: 1000,
      });
  
    } catch (error) {
      props.handleClose();
  
      Swal.fire({
        title: 'Error',
        text: 'There was an error adding the record.',
        icon: 'error',
      });
    }
  };
  
  const onSubmitUpdate = async (data) => {
    try {
  
      const postData = {
        ...data,
        name: data.name || props.name,
        id: nodeId,
        defaultpracticeId: props.defaultpracticeId,
        description: data.nodesvalues !== undefined ? data.nodesvalues : props.nodesvalues,
        parentId: parentId,
      };
  
      const response = await axios.post(
        `${process.env.REACT_APP_API_URL}/Module/AddRoles?defaultpracticeId=${localStorage.getItem('default_paractice')}`,
        postData,
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      );
  
      console.log('Submission successful:', response.data);
  
      props.applyRefresh();
      props.handleClose();
  
      Swal.fire({
        title: 'Record Updated',
        text: 'Record updated successfully',
        icon: 'success',
        timer: 1000,
      });
  
    } catch (error) {
      console.error('Submission failed:', error);
  
      Swal.fire({
        title: 'Error',
        text: 'There was an error updating the record.',
        icon: 'error',
      });
  
    } 
  };
  

  const onDelete = async () => {
    try {
      const postData = {
        ...data,
        name: data.name || props.name,
        id: nodeId,
        inactive: true,
        defaultpracticeId: props.defaultpracticeId,
        values: data.nodesvalues !== undefined ? data.nodesvalues : props.nodesvalues,
        parentId: parentId,
        description: ''
      };
  
      const response = await axios.post(
        `${process.env.REACT_APP_API_URL}/Module/AddRoles?defaultpracticeId=${localStorage.getItem('default_paractice')}`,
        postData,
        {
          headers: {
            Authorization: `Bearer ${token}`
          }
        }
      );
  
      // Handle successful response
      console.log('Submission successful:', response.data);
      setRefresh(!refresh);
      props.applyRefresh();
      
      // Show success popup
      Swal.fire({
        title: 'Record Deleted',
        text: 'Record deleted successfully',
        icon: 'success',
        timer: 1000,
      });
  
      props.handleClose();
  
    } catch (error) {
      // Handle errors
      console.error('Submission failed:', error);
  
      // Show error popup
      Swal.fire({
        title: 'Error',
        text: 'There was an error deleting the record.',
        icon: 'error',
      });
  
    } finally {
      // Optional: Any final operations if needed
      // Example: Reset state, close loading spinner, etc.
    }
  };


  return (
    <>
      <Grid item xs={12} sm={12} xl={12}  >
        
        <Headroom>
         <Grid
              container
              style={{ backgroundColor: '#356F60', position: 'sticky' }}
            >
             <Grid item xs={12} sm={12} xl={12}>
                <div
                  style={{
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'space-between',
                    height: '100%'
                  }}
                >
                <DialogTitle
                    style={{
                      flex: 1,
                      textAlign: 'center',
                    }}
                  >
                    <h1
                      style={{
                        fontWeight: 'bold',
                        textAlign: 'center',
                        color: '#fff',
                        // textDecoration: 'underline',
                        fontSize:'1.3rem'

                      }}
                    >
                     {props.update ? 'Update Roles': 'Add Roles'}
                    </h1>
                  </DialogTitle>
                  <CancelOutlinedIcon
              onClick={() => props.handleClose()}
                 fontSize="large"
                 color="red"
                 style={{
                   color: 'red',
                   paddingRight: '5px',
                   cursor: 'pointer',
                   float:'right'
                   // marginLeft: 'auto',
                   // marginRight: '1.5rem'
                 }}
               ></CancelOutlinedIcon>

                </div>
                </Grid>
            </Grid>
 </Headroom>
 </Grid>
  
      <Grid container spacing={2} style={{padding:'10px'}}>
        <Grid item xs={12} sm={6}>
          <Box mb={2}>
            <label htmlFor="name">Name</label>
            <Controller
              name="name"
              control={control}
              defaultValue={props.name || ''}
              render={({ field }) => (
                <TextField
                  id="name"
                  size='small'
                  fullWidth
                  {...field}
                  error={Boolean(errors.name)}
                  helperText={errors.name ? 'Name is required' : ''}
                />
              )}
            />
          </Box>
        </Grid>
        <Grid item xs={12} sm={6}>
          <Box mb={2}>
            <label htmlFor="nodesvalues">Value</label>
            <Controller
              name="nodesvalues"
              control={control}
              render={({ field }) => (
                <TextField
                  id="nodesvalues"
                  fullWidth
                  size='small'
                  {...field}
                  value={field.value}
                  defaultValue={props.nodesvalues || ''}
                  error={Boolean(errors.nodesvalues)}
                  helperText={errors.nodesvalues ? 'Value is required' : ''}
                />
              )}
            />
          </Box>
        </Grid>
  
        <Grid container alignItems="right" style={{padding:'15px',marginTop:'20px'}}>
        <Grid item xs={props.update ? 2:5}></Grid>
          <Grid item xs={3}>
              <Button
              className="Button"
              onClick={() => props.handleClose()}
              style={{
                marginBottom: '10px',
                float: 'right',
                marginLeft: '20px',
                width: '120px',
                height: '35px',
                // backgroundColor: '#A574FD',
                color: 'white',
                fontSize: '14px'
              }}
            >
              <Clear
                fontSize='medium'
                style={{
                  color: 'white',
                  marginRight: '1px',
                  paddingRight: '0px',
                  paddingBottom: '2px',

                }}
              ></Clear>
              Clear
            </Button>
          </Grid>
          {/* Submit Buttons */}
          {props.update ? (
            <>
              {/* Update Button */}
        <Grid item xs={0.5}></Grid>

              <Grid item xs={3}>
                  <Button
                    type="submit"
                    className="Button"
                    style={{
                      marginBottom: '10px',
                      float: 'right',
                      marginLeft: '20px',
                      width: '120px',
                      height: '35px',
                      // backgroundColor: '#A574FD',
                      color: 'white',
                      fontSize: '14px'
                    }}
                    onClick={handleSubmit(onSubmitUpdate)}
                  >
                    <SaveOutlinedIcon
                       fontSize='medium'
                       style={{
                         color: 'white',
                         marginRight: '1px',
                         paddingRight: '0px',
                         paddingBottom: '2px',
       
                       }}
                    />Update
                  </Button>
              </Grid>
        <Grid item xs={0.5}></Grid>

              <Grid item xs={3}>
                <Button
                  onClick={() => setIsDialogOpen(true)}
                  style={{
                    marginBottom: '10px',
                    float: 'right',
                    marginLeft: '20px',
                    width: '120px',
                    height: '35px',
                    backgroundColor: 'red',
                    color: 'white',
                    fontSize: '14px'
                  }}
                >
                  <DeleteIcon   fontSize='medium'
                       style={{
                         color: 'white',
                         marginRight: '1px',
                         paddingRight: '0px',
                         paddingBottom: '2px',
       
                       }}
                    /> 
                  Delete
                </Button>
              </Grid>
            </>
          ) : (
            <>
              {/* Save Button */}
        <Grid item xs={0.5}></Grid>

              <Grid item xs={3}>
              <Button
              className="Button"
              style={{
                marginBottom: '10px',
                float: 'right',
                marginLeft: '20px',
                width: '120px',
                height: '35px',
                // backgroundColor: '#A574FD',
                color: 'white',
                fontSize: '14px'
              }}
              onClick={handleSubmit(onSubmit)}
            >
                  <SaveOutlinedIcon
                     fontSize='medium'
                     style={{
                       color: 'white',
                       marginRight: '1px',
                       paddingRight: '0px',
                       paddingBottom: '2px',
     
                     }}
                  />
                 SAVE
                </Button>
              </Grid>
            </>
          )}
        </Grid>
      </Grid>
  
    {/* Dialog */}
    <Dialog
      open={isDialogOpen}
      onClose={() => setIsDialogOpen(false)}
      aria-labelledby="alert-dialog-title"
      aria-describedby="alert-dialog-description"
      BackdropComponent={Backdrop}
      BackdropProps={{
        timeout: 500,
        invisible: true,
      }}
      PaperProps={{
        style: {
          background: '#f9fbe7',
          boxShadow: '0 4px 12px rgba(0, 0, 0, 0.2)',
          borderRadius: '12px',
          padding: '24px',
        },
      }}
    >
      <div style={{ textAlign: 'center', width: '100%' }}>
        <ErrorOutlineIcon
          style={{
            fontSize: '100px',
            color: '#d32f2f',
            marginBottom: '10px',
          }}
        />
        <DialogTitle
          id="alert-dialog-title"
          style={{
            fontWeight: 'bold',
            marginBottom: '20px',
            color: '#2e2e2e',
          }}
        >
          Do you want to delete the record?
        </DialogTitle>
        <DialogContent>
          <DialogContentText id="alert-dialog-description">
            This action cannot be undone.
          </DialogContentText>
        </DialogContent>
        <DialogActions style={{ justifyContent: 'center', marginBottom: '20px' }}>
          <Button
            onClick={() => onDelete()}
            variant="contained"
            style={{
              backgroundColor: '#d32f2f',
              color: 'white',
              padding: '6px 20px',
              borderRadius: '6px',
            }}
          >
            YES
          </Button>
          <Button
            onClick={() => setIsDialogOpen(false)}
            variant="outlined"
            style={{
              marginLeft: '1rem',
              borderColor: '#388e3c',
              color: '#388e3c',
              padding: '6px 20px',
              borderRadius: '6px',
            }}
          >
            NO
          </Button>
        </DialogActions>
      </div>
    </Dialog>
  </>
  

  );
};

export default MyFormRoles;
